import {
  Box,
  CopyToClipboard,
  IconButton,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { EventPayloadT } from 'lib-shared-legacy-types';

import { useCopyWithDelay } from 'hooks/useCopyWithDelay';

import styles from './payloadModal.module.scss';

type PayloadModalProps = {
  payload: EventPayloadT;
  isOpen: boolean;
  onClose: () => void;
};

export function PayloadModal({
  payload,
  isOpen,
  onClose,
}: PayloadModalProps): JSX.Element {
  const { isCopied, setIsCopied } = useCopyWithDelay(false);

  const jsonPayload = JSON.stringify(payload, null, 2);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHead title="Payload" onClose={onClose} />
      <ModalBody className={styles.body}>
        <Box className={styles.payloadContent}>
          <CopyToClipboard
            textToCopy={jsonPayload}
            tooltip={false}
            onClick={() => setIsCopied(true)}
            className={styles.payloadCopyIconWrapper}
          >
            <Tooltip content={isCopied ? 'Copied' : 'Copy payload'}>
              <IconButton
                data-testid="webhooks-payload-copy-button"
                icon={isCopied ? 'done' : 'copy'}
                variant="secondary"
                className={styles.payloadCopyIcon}
              />
            </Tooltip>
          </CopyToClipboard>
          <pre className={styles.payloadContentCode}>{jsonPayload}</pre>
        </Box>
      </ModalBody>
      <ModalFoot confirmName="Close" confirmOnClick={onClose}></ModalFoot>
    </Modal>
  );
}
